import { connect } from "react-redux";
import React, { useMemo } from 'react';
import { RainBonus } from "./RainBonus";
import { DispatchAutoSwitch } from "./DispatchAutoSwitch";
import useEnableDQP from "../hooks/useEnableDQP";
import useUpdateDQPAddedDelays from "../hooks/useUpdateDQPAddedDelays";

export const DQPs = connect(
  (state) => {
    return {
      currentCenterId: state.dispatch.metas.current_center_id,
      centerExtraDelay: state.dispatch.metas.extra_delay,
      centerExpressExtraDelay: state.dispatch.metas.express_extra_delay,
      centerExpressPrioExtraDelay: state.dispatch.metas.express_prio_extra_delay,

      centerDqpExpressEnabled: state.dispatch.metas.dqp_express_enabled,
      centerDqpExpressPrioEnabled: state.dispatch.metas.dqp_express_prio_enabled,
      centerDqpCourierEnabled: state.dispatch.metas.dqp_courier_enabled,
      // center added delay
      centerDqpExtraAddedDelay: state.dispatch.metas.dqp_extra_added_delay,
      centerDqpNearbyExtraAddedDelay: state.dispatch.metas.dqp_nearby_extra_added_delay,
      // fm only (centersite)
      frichtiExtraDelay: state.dispatch.metas.frichti_extra_delay,
      // frichtiExpressExtraDelay: state.dispatch.metas.frichti_express_extra_delay,
      // frichtiDqpExpressEnabled: state.dispatch.metas.frichti_dqp_express_enabled,
      frichtiExpressPrioExtraDelay: state.dispatch.metas.frichti_express_prio_extra_delay,
      frichtiDqpExpressPrioEnabled: state.dispatch.metas.frichti_dqp_express_prio_enabled,
      // fm only (centersite) added delay
      frichtiDqpExtraAddedDelay: state.dispatch.metas.frichti_dqp_extra_added_delay,
      frichtiDqpNearbyExtraAddedDelay: state.dispatch.metas.frichti_dqp_nearby_extra_added_delay,
    };
  }
)(({
  centerExtraDelay,
  centerExpressExtraDelay,
  centerExpressPrioExtraDelay,
  centerDqpExpressEnabled,
  centerDqpExpressPrioEnabled,
  centerDqpCourierEnabled,
  centerDqpExtraAddedDelay,
  centerDqpNearbyExtraAddedDelay,
  frichtiExtraDelay,
  frichtiExpressPrioExtraDelay,
  // frichtiExpressExtraDelay,
  // frichtiDqpExpressEnabled,
  frichtiDqpExpressPrioEnabled,
  frichtiDqpExtraAddedDelay,
  frichtiDqpNearbyExtraAddedDelay,
  dispatch,
}) => {
  const currentCenterId = useMemo(() => {
    let rawSessionCenterId = window.sessionStorage.getItem('flow_current_center');
    let sessionCenterId = parseInt(rawSessionCenterId, 10);
    if (!isNaN(sessionCenterId)) {
      return sessionCenterId;
    }
    return null;
  }, []);

  const { frichtiDQPExpressPrioIsEnabled,
    handleFrichtiDQPExpressPrioToggle,
    // frichtiDQPExpressIsEnabled,
    // handleFrichtiDQPExpressToggle,
    centerDQPCourierIsEnabled,
    handleCenterDQPCourierToggle,
    centerDQPExpressPrioIsEnabled,
    handleCenterDQPExpressPrioToggle,
    centerDQPExpressIsEnabled,
    handleCenterDQPExpressToggle } = useEnableDQP({
    currentCenterId,
    centerDqpExpressEnabled,
    centerDqpCourierEnabled,
    centerDqpExpressPrioEnabled,
    // frichtiDqpExpressEnabled,
    frichtiDqpExpressPrioEnabled,
    dispatch,
  });

  const {
    frichtiAddedDelay, setFrichtiAddedDelay,
    frichtiNearbyAddedDelay,
    setFrichtiNearbyAddedDelay,
    centerAddedDelay,
    setCenterAddedDelay,
    centerNearbyAddedDelay,
    setCenterNearbyAddedDelay,
    onSaveCenterAddedDelay,
    onSaveCenterNearbyAddedDelay,
    onSaveFrichtiAddedDelay,
    onSaveFrichtiNearbyAddedDelay,
  } = useUpdateDQPAddedDelays({
    frichtiDqpExtraAddedDelay,
    frichtiDqpNearbyExtraAddedDelay,
    centerDqpExtraAddedDelay,
    centerDqpNearbyExtraAddedDelay,
    currentCenterId,
    dispatch,
  });

  const centerTotalExtraDelays = useMemo(() => {
    return {
      nearby: Number(centerExtraDelay || 0) + Number(centerNearbyAddedDelay || 0),
      idf: Number(centerExtraDelay || 0) + Number(centerAddedDelay || 0),
    };
  }, [centerExtraDelay, centerNearbyAddedDelay, centerAddedDelay]);

  const centerTotalExpressExtraDelays = useMemo(() => {
    return {
      nearby: Number(centerExpressExtraDelay || 0) + Number(centerNearbyAddedDelay || 0),
      idf: Number(centerExpressExtraDelay || 0) + Number(centerAddedDelay || 0),
    };
  }, [centerExpressExtraDelay, centerNearbyAddedDelay, centerAddedDelay]);

  const centerTotalExpressPrioExtraDelays = useMemo(() => {
    return {
      nearby: Number(centerExpressPrioExtraDelay || 0) + Number(centerNearbyAddedDelay || 0),
      idf: Number(centerExpressPrioExtraDelay || 0) + Number(centerAddedDelay || 0),
    };
  }, [centerExpressPrioExtraDelay, centerNearbyAddedDelay, centerAddedDelay]);

  const frichtiTotalExpressPrioExtraDelays = useMemo(() => {
    return {
      nearby: Number(frichtiExpressPrioExtraDelay || 0) + Number(frichtiNearbyAddedDelay || 0),
      idf: Number(frichtiExpressPrioExtraDelay || 0) + Number(frichtiAddedDelay || 0),
    };
  }, [frichtiExpressPrioExtraDelay, frichtiNearbyAddedDelay, frichtiAddedDelay]);

  // const frichtiTotalExpressExtraDelays = useMemo(() => {
  //   return {
  //     nearby: Number(frichtiExpressExtraDelay || 0) + Number(frichtiNearbyAddedDelay || 0),
  //     idf: Number(frichtiExpressExtraDelay || 0) + Number(frichtiAddedDelay || 0),
  //   };
  // }, [frichtiExpressExtraDelay, frichtiNearbyAddedDelay, frichtiAddedDelay]);

  const frichtiTotalExtraDelays = useMemo(() => {
    return {
      nearby: Number(frichtiExtraDelay || 0) + Number(frichtiNearbyAddedDelay || 0),
      idf: Number(frichtiExtraDelay || 0) + Number(frichtiAddedDelay || 0),
    };
  }, [frichtiExtraDelay, frichtiNearbyAddedDelay, frichtiAddedDelay]);


  return (
    <h4>
      <div className="dqp-header">
        <div>
          [
          <input
            type="checkbox"
            checked={frichtiDQPExpressPrioIsEnabled}
            onChange={(e) => handleFrichtiDQPExpressPrioToggle(e.target.checked)}
          // disabled={disableForm}
          /> {`Frichti EXPRESS PRIO DQP: ${frichtiTotalExpressPrioExtraDelays.nearby}/${frichtiTotalExpressPrioExtraDelays.idf}`}
          ]
        </div>
        <div>
          [
          {`Frichti DQP: ${frichtiTotalExtraDelays.nearby}/${frichtiTotalExtraDelays.idf}`}
          ]
        </div>
        <div>
          [
          <input
            type="checkbox"
            checked={centerDQPCourierIsEnabled}
            onChange={(e) => handleCenterDQPCourierToggle(e.target.checked)}
          // disabled={disableForm}
          /> DQP Coursier privé
          ]
        </div>
        <div>
          [
          <input
            type="checkbox"
            checked={centerDQPExpressPrioIsEnabled}
            onChange={(e) => handleCenterDQPExpressPrioToggle(e.target.checked)}
          // disabled={disableForm}
          /> {`EXPRESS PRIO DQP: ${centerTotalExpressPrioExtraDelays.nearby}/${centerTotalExpressPrioExtraDelays.idf}`}
          ]
        </div>
        <div>
          [
          <input
            type="checkbox"
            checked={centerDQPExpressIsEnabled}
            onChange={(e) => handleCenterDQPExpressToggle(e.target.checked)}
          // disabled={disableForm}
          /> {`EXPRESS DQP: ${centerTotalExpressExtraDelays.nearby}/${centerTotalExpressExtraDelays.idf}`}
          ]
        </div>
        <div>
          [
          {`DQP: ${centerTotalExtraDelays.nearby}/${centerTotalExtraDelays.idf}`}
          ]
        </div>
      </div>
      <div className="dqp-added-delays">
        <div>
            FM proche:
          <input
            type="number"
            value={frichtiNearbyAddedDelay}
            onChange={(e) => setFrichtiNearbyAddedDelay(e.target.value)}
            min="0"
            autoComplete="off"
          />
          <button className={`btn btn-default btn-xs ${frichtiNearbyAddedDelay != frichtiDqpNearbyExtraAddedDelay ? 'changed' : ''}`} type="button" onClick={onSaveFrichtiNearbyAddedDelay}>OK</button>
        </div>
        <div>
            FM IDF:
          <input
            type="number"
            value={frichtiAddedDelay}
            onChange={(e) => setFrichtiAddedDelay(e.target.value)}
            min="0"
            autoComplete="off"
          />
          <button className={`btn btn-default btn-xs ${frichtiAddedDelay != frichtiDqpExtraAddedDelay ? 'changed' : ''}`} type="button" onClick={onSaveFrichtiAddedDelay}>OK</button>
        </div>
        <div>
            Proche:
          <input
            type="number"
            value={centerNearbyAddedDelay}
            onChange={(e) => setCenterNearbyAddedDelay(e.target.value)}
            min="0"
            autoComplete="off"
          />
          <button className={`btn btn-default btn-xs ${centerNearbyAddedDelay != centerDqpNearbyExtraAddedDelay ? 'changed' : ''}`} type="button" onClick={onSaveCenterNearbyAddedDelay}>OK</button>
        </div>
        <div>
            IDF:
          <input
            type="number"
            value={centerAddedDelay}
            onChange={(e) => setCenterAddedDelay(e.target.value)}
            min="0"
            autoComplete="off"
          />
          <button className={`btn btn-default btn-xs ${centerAddedDelay != centerDqpExtraAddedDelay ? 'changed' : ''}`} type="button" onClick={onSaveCenterAddedDelay}>OK</button>
        </div>
        <RainBonus />
        <DispatchAutoSwitch />
      </div>
    </h4>
  );
});